import {ReactNode} from 'react';
import { Form, FormInstance } from 'antd';
import './form.scss';

type FormComponentParams<T> = {
    className?: string
    form: FormInstance<T>
    onFinish: (values: any) => void
    onValuesChange?: (changedValues: any, allValues: any) => void
    onFinishFailed?: ({ values, errorFields, outOfDate }:{values:any, errorFields:any, outOfDate:any}) => void
    initialValues: {}
    validateTrigger?: string | string[]
    name: string
    children: ReactNode
}

const FormComponent = <T extends Object>({
    className = '',
    form,
    onFinish,
    onValuesChange,
    onFinishFailed,
    initialValues,
    validateTrigger = 'onSubmit',
    name = '',
    ...props
}:FormComponentParams<T>) => {
    return (
        <Form<T>
            className={className}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            form={form}
            onFinishFailed={onFinishFailed}
            initialValues={initialValues}
            validateTrigger={validateTrigger}
            name={name}
        >
            {props?.children}
        </Form>
    );
};

export default FormComponent;

const UseForm = () => {
    return Form.useForm();
};

export { UseForm };
